import _regeneratorRuntime from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _createForOfIteratorHelper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _asyncToGenerator from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import e from "../../../request.js";
import t from "../../../core/Error.js";
import r from "../../../core/Logger.js";
import { eachAlways as s } from "../../../core/promiseUtils.js";
import { isNumericField as i } from "../../../layers/support/fieldUtils.js";
import o from "../../../rest/support/Query.js";
import n from "../../../rest/support/RelationshipQuery.js";
import a from "../../../rest/support/StatisticDefinition.js";
import l from "../../../tasks/QueryTask.js";
import { isRelatedField as u } from "./featureUtils.js";
var c = "esri.widgets.Feature.support.relatedFeatureUtils",
    d = r.getLogger(c),
    f = new Map();

function p(e) {
  if (!u(e)) return null;

  var _e$split$slice = e.split("/").slice(1),
      _e$split$slice2 = _slicedToArray(_e$split$slice, 2),
      t = _e$split$slice2[0],
      r = _e$split$slice2[1];

  return {
    layerId: t,
    fieldName: r
  };
}

function m(e, t) {
  if (!t.relationships) return null;
  var r = null;
  var s = t.relationships;
  return s.some(function (t) {
    return t.id === parseInt(e, 10) && (r = t, !0);
  }), r;
}

function y(_ref) {
  var e = _ref.originRelationship,
      t = _ref.relationships,
      r = _ref.layerId;
  var s;
  return t && t.some(function (t) {
    return "".concat(t.relatedTableId) === r && t.id === e.id && (s = t), !!s;
  }), s;
}

function F(e, t) {
  var r = t.toLowerCase();

  for (var _s in e) {
    if (_s.toLowerCase() === r) return e[_s];
  }

  return null;
}

function h(e, t) {
  var r = m(e, t);
  if (!r) return;
  var s = "".concat(t.url, "/").concat(r.relatedTableId);
  return {
    url: s,
    queryTask: new l({
      url: s,
      sourceSpatialReference: t.spatialReference
    }),
    relation: r,
    relatedFields: [],
    outStatistics: []
  };
}

function I(e, t) {
  if (!t) return;
  if (!e) return;
  var r = e.features,
      s = e.statsFeatures,
      i = r && r.value;
  t.relatedFeatures = i ? i.features : [];
  var o = s && s.value;
  t.relatedStatsFeatures = o ? o.features : [];
}

function w(e, t, r, s) {
  var i = new n();
  return i.outFields = ["*"], i.relationshipId = "number" == typeof t.id ? t.id : parseInt(t.id, 10), i.objectIds = [e.attributes[r.objectIdField]], r.queryRelatedFeatures(i, s);
}

function b(e, t, r) {
  var s = 0;
  var i = [];

  for (; s < t.length;) {
    i.push("".concat(e, " IN (").concat(t.slice(s, r + s), ")")), s += r;
  }

  return i.join(" OR ");
}

function j(_x, _x2, _x3, _x4) {
  return _j.apply(this, arguments);
}

function _j() {
  _j = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(e, t, r, n) {
    var a, l, u, c, d, f, p, _t, _i, _e3, _r2, m, _r3, _a, _d, _f, _p, _y;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            a = r.layerId.toString(), l = t.layerInfo, u = t.queryTask, c = t.relation, d = t.relatedFields, f = t.outStatistics, p = y({
              originRelationship: c,
              relationships: l.relationships,
              layerId: a
            });

            if (!(p.relationshipTableId && p.keyFieldInRelationshipTable)) {
              _context.next = 14;
              break;
            }

            _context.next = 4;
            return w(e, p, r, n);

          case 4:
            _context.t0 = e.attributes[r.objectIdField];
            _t = _context.sent[_context.t0];

            if (_t) {
              _context.next = 8;
              break;
            }

            return _context.abrupt("return", null);

          case 8:
            _i = _t.features.map(function (e) {
              return e.attributes[l.objectIdField];
            });

            if (!((null == f ? void 0 : f.length) > 0 && l.supportsStatistics)) {
              _context.next = 14;
              break;
            }

            _e3 = new o();
            _e3.where = b(l.objectIdField, _i, 1e3), _e3.outFields = d, _e3.outStatistics = f;
            _r2 = {
              features: Promise.resolve(_t),
              statsFeatures: u.execute(_e3)
            };
            return _context.abrupt("return", s(_r2));

          case 14:
            m = null == p ? void 0 : p.keyField;

            if (!m) {
              _context.next = 18;
              break;
            }

            _r3 = i(q(l.fields, m)), _a = F(e.attributes, c.keyField), _d = _r3 ? "".concat(m, "=").concat(_a) : "".concat(m, "='").concat(_a, "'"), _f = u.execute(new o({
              where: _d,
              outFields: t.relatedFields
            }), n), _p = t.outStatistics && t.outStatistics.length > 0 && l.supportsStatistics ? u.execute(new o({
              where: _d,
              outFields: t.relatedFields,
              outStatistics: t.outStatistics
            }), n) : null, _y = {
              features: _f
            };
            return _context.abrupt("return", (_p && (_y.statsFeatures = _p), s(_y)));

          case 18:
            return _context.abrupt("return", null);

          case 19:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _j.apply(this, arguments);
}

function g(t, r) {
  return e(t, {
    query: {
      f: "json"
    },
    signal: r && r.signal
  });
}

function S(_ref2, i) {
  var e = _ref2.relatedInfos,
      r = _ref2.layer;
  var o = {};
  return e.forEach(function (e, s) {
    var n = e.relation;

    if (!n) {
      var _e = new t("relation-required", "A relation is required on a layer to retrieve related records.");

      throw d.error(_e), _e;
    }

    var a = n.relatedTableId;

    if ("number" != typeof a) {
      var _e2 = new t("A related table ID is required on a layer to retrieve related records.");

      throw d.error(_e2), _e2;
    }

    var l = "".concat(r.url, "/").concat(a),
        u = f.get(l),
        c = u || g(l, i);
    u || f.set(l, c), o[s] = c;
  }), s(o);
}

function T(_ref3, i) {
  var e = _ref3.graphic,
      t = _ref3.relatedInfos,
      r = _ref3.layer;
  var o = {};
  return t.forEach(function (t, s) {
    t.layerInfo && (o[s] = j(e, t, r, i));
  }), s(o);
}

function $(_ref4) {
  var e = _ref4.relatedInfo,
      t = _ref4.fieldName,
      r = _ref4.fieldInfo;

  if (e.relatedFields.push(t), r.statisticType) {
    var _s2 = new a({
      statisticType: r.statisticType,
      onStatisticField: t,
      outStatisticFieldName: t
    });

    e.outStatistics.push(_s2);
  }
}

function q(e, t) {
  if (null != e) {
    t = t.toLowerCase();

    var _iterator = _createForOfIteratorHelper(e),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _r = _step.value;
        if (_r && _r.name.toLowerCase() === t) return _r;
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return null;
}

export { h as createRelatedInfo, y as getDestinationRelation, p as getRelatedFieldInfo, S as queryLayerInfos, T as queryRelatedFeatures, I as setRelatedFeatures, $ as updateRelatedInfo };